export enum CampaignType {
    SMS = 0,
    EMAIL = 1,
    VIBER = 2
}
